"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _antd = require("antd");
var _Dropdown = require("./Dropdown.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 下拉選單
 */

const Dropdown = _ref => {
  let {
    list,
    children,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_antd.Dropdown, {
    overlay: /*#__PURE__*/_react.default.createElement(_antd.Menu, null, list.map((li, key) => {
      return /*#__PURE__*/_react.default.createElement(_antd.Menu.Item, {
        key: key,
        onClick: () => li.onClick && li.onClick(),
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, li.icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        style: {
          marginRight: "5px"
        },
        name: li.icon
      }), li.name);
    }))
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.UiDropdown, {
    className: className
  }, children));
};
var _default = exports.default = Dropdown;
Dropdown.propTypes = {
  list: _propTypes.default.array,
  children: _propTypes.default.element,
  className: _propTypes.default.string
};